export class SignupFormConfigModel {
    public signupFormConfigHashId: string;
    public instanceHashId: string = '';
    public title: string = '';
    public description: string = '';
    public formLogoPath: string = '';
    public footerText: string = '';
    public successURL: string = 'https://bo.wego.app/';
    public sendActivationMail: boolean = false;
    public sendConfirmationMail: boolean = false;
    public adminApprovalRequired: boolean = false;
    public canApprovedByCompanyAdmin: boolean = false;
    public canApprovedByGroupAdmin: boolean = false;
    public canApprovedByOrganizationAdmin: boolean = false;
    public validEmailDomain: string = '';
    public fieldPassword: boolean = true;
    public fieldFirstName: boolean = false;
    public fieldMiddleName: boolean = false;
    public fieldLastName: boolean = false;
    public fieldMobileNumber: boolean = false;
    public fieldPhoneNumber: boolean = false;
    public fieldHomeAddress: boolean = false;
    public fieldNIFNumber: boolean = false;
    public instanceName: string = '';
    public isChecked: boolean;
    public svgFilter: string = '';
    public subscriptionList: SubscriptionForSignupForm[];
    public signupParameter: string;
    public validateLiceanceNumber: boolean;
    public subscriptionListsortType: string = "";
    public subscriptionListSortReverse: boolean;
    public svgWiseSubscriptionList: any;
    public organizationHashId: string='';
    public isDeletable : boolean;
    public isEditable : boolean;
    public countryCode1: string = '';
    public countryCode2: string = '';
    public isnifEnabled: boolean = false;
    public defaultCountryHashId:string;
}

export class SubscriptionForSignupForm {
    public subscriptiopnListHashId: string;
    public subscriptionHashId: string;
    public svgName: string;
    public subscriptionName: string;
    public status: boolean;
    public statusString: string;
    public isChecked: boolean;
    public hide: boolean;

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/models/signupformconfig.model.ts